import(/* webpackMode: "eager" */ "/app/app/(providers)/general-surgery-detailpage/page.js");
